import { AnyAction, Dispatch, Middleware, MiddlewareAPI } from 'redux';
import ActionTypes from "../../../../constants/ActionTypes";
import ApiUrls from "../../../../constants/ApiUrls";
import MiddlewareEntities from "../../../../constants/MiddlewareEntities";
import { setLoader } from "../../ui/actions";
import { getSessionData } from "../../sessionData/actions";
import { createErrorNotification, getNotification } from "../../notification/actions";
import { apiRequest } from '../../api/actions';
import { HttpConstants } from "../../../../constants/HttpConstants";
import {
  setAcceptanceOptionNameAction,
  setAcceptanceSoftOfferPackageAction, setAcceptanceTermsAction,
  setCampaignAcceptanceDataAction, setCampaignAcceptanceStatusAction
} from "./actions";
import SoftOfferPackageFactory from "../../../../factories/campaigns/SoftOfferPackageFactory";
import { CampaignConstants } from "../../../../constants/CampaignConstants";
import _ from "lodash";
import SoftOfferPackage from '../../../../entities/campaigns/tps/SoftOfferPackage';

export const getCampaignAcceptanceDataMiddleware: Middleware = (store: MiddlewareAPI) => (next: Dispatch) => (action: AnyAction) => {
  next(action);
  switch (action.type) {
  case ActionTypes.CAMPAIGN.ACCEPTANCE.FETCH:
    next(apiRequest(
      null,
      HttpConstants.methods.GET,
      `${ApiUrls.CAMPAIGNS}/email-acceptance-view/${action.params.code}/${action.params.offerId}/${action.params.optionId}/${action.params.tpId}`,
      null,
      null,
      MiddlewareEntities.CAMPAIGN.ACCEPTANCE.ALL,
      {}),
    );
    next(setLoader(true, MiddlewareEntities.CAMPAIGN.ACCEPTANCE.ALL));
    break;
  case `${MiddlewareEntities.CAMPAIGN.ACCEPTANCE.ALL} ${ActionTypes.API_SUCCESS}` :
    next(setCampaignAcceptanceDataAction(action.payload.data));
    next(getSessionData(action.payload.data.session));
    next(getNotification(action.payload.data.session.flashMessages,  MiddlewareEntities.CAMPAIGN.ACCEPTANCE.ALL));
    next(setLoader(false, MiddlewareEntities.CAMPAIGN.ACCEPTANCE.ALL));
    break;
  case `${MiddlewareEntities.CAMPAIGN.ACCEPTANCE.ALL} ${ActionTypes.API_ERROR}` :
    next(setLoader(false, MiddlewareEntities.CAMPAIGN.ACCEPTANCE.ALL));
    next(createErrorNotification(action.payload.data,  MiddlewareEntities.CAMPAIGN.ACCEPTANCE.ALL));
    break;
  }
};

export const createCampaignAcceptanceMiddleware: Middleware = (store: MiddlewareAPI) => (next: Dispatch) => (action: AnyAction) => {
  next(action);

  if (action.type.includes(ActionTypes.CAMPAIGN.ACCEPTANCE.SET_ACCEPTANCE_DATA)) {
    const tpOffer: SoftOfferPackage = SoftOfferPackageFactory.create(action.payload.campaignData.tp);
    next(setAcceptanceSoftOfferPackageAction(tpOffer));
    next(setAcceptanceOptionNameAction(action.payload.campaignData.optionName));
    const termsText = _.replace(action.payload.terms, '<MFDISCOUNT>', String(tpOffer.getFinalPrice()));
    next(setAcceptanceTermsAction(termsText));
    next(setCampaignAcceptanceStatusAction(action.payload.cssConfirmationStatus === CampaignConstants.acceptance.status.GIVEN));
  }
};

export const giveCampaignAcceptanceMiddleware: Middleware = (store: MiddlewareAPI) => (next: Dispatch) => (action: AnyAction) => {
  next(action);
  switch (action.type) {
  case ActionTypes.CAMPAIGN.ACCEPTANCE.GIVE_ACCEPTANCE:
    next(apiRequest(
      null,
      HttpConstants.methods.POST,
      `${ApiUrls.CAMPAIGNS}/email-acceptance/${action.params.code}/${action.params.offerId}/${action.params.optionId}/${action.params.tpId}`,
      null,
      null,
      MiddlewareEntities.CAMPAIGN.ACCEPTANCE.STATUS,
      {}),
    );
    next(setLoader(true, MiddlewareEntities.CAMPAIGN.ACCEPTANCE.STATUS));
    break;
  case `${MiddlewareEntities.CAMPAIGN.ACCEPTANCE.STATUS} ${ActionTypes.API_SUCCESS}` :
    next(setCampaignAcceptanceStatusAction(true));
    next(getSessionData(action.payload.data.session));
    next(getNotification(action.payload.data.session.flashMessages,  MiddlewareEntities.CAMPAIGN.ACCEPTANCE.STATUS));
    next(setLoader(false, MiddlewareEntities.CAMPAIGN.ACCEPTANCE.STATUS));
    break;
  case `${MiddlewareEntities.CAMPAIGN.ACCEPTANCE.STATUS} ${ActionTypes.API_ERROR}` :
    next(setCampaignAcceptanceStatusAction(false));
    next(setLoader(false, MiddlewareEntities.CAMPAIGN.ACCEPTANCE.STATUS));
    next(createErrorNotification(action.payload.data,  MiddlewareEntities.CAMPAIGN.ACCEPTANCE.STATUS));
    break;
  }
};

export const campaignAcceptanceMiddleware = [
  getCampaignAcceptanceDataMiddleware,
  createCampaignAcceptanceMiddleware,
  giveCampaignAcceptanceMiddleware
];
